export enum NotificationTypeEnum {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  TASK = 'task',
  APPROVAL = 'approval',
  REMINDER = 'reminder',
  SYSTEM = 'system',
  SECURITY = 'security',
  BILLING = 'billing',
  INVENTORY = 'inventory',
  SALES = 'sales',
  PURCHASE = 'purchase',
  FINANCIAL = 'financial',
  REPORT = 'report',
  INTEGRATION = 'integration',
  OTHER = 'other'
}

export enum NotificationCategoryEnum {
  GENERAL = 'general',
  STOCK_LOW = 'stock_low',
  STOCK_OUT = 'stock_out',
  STOCK_OVERSTOCKED = 'stock_overstocked',
  BATCH_EXPIRING = 'batch_expiring',
  BATCH_EXPIRED = 'batch_expired',
  SALE_CREATED = 'sale_created',
  SALE_CANCELLED = 'sale_cancelled',
  SALE_REFUNDED = 'sale_refunded',
  PAYMENT_RECEIVED = 'payment_received',
  PAYMENT_FAILED = 'payment_failed',
  TITLE_DUE = 'title_due',
  TITLE_OVERDUE = 'title_overdue',
  PURCHASE_RECEIVED = 'purchase_received',
  PURCHASE_DELAYED = 'purchase_delayed',
  REPORT_READY = 'report_ready'
}

export enum NotificationPriorityEnum {
  LOW = 'low',
  NORMAL = 'normal',
  HIGH = 'high',
  URGENT = 'urgent',
  CRITICAL = 'critical'
}

export enum NotificationStatusEnum {
  UNREAD = 'unread',
  READ = 'read'
}
